import React, { useState, useEffect, useContext, useRef } from "react";
import { Helmet } from "react-helmet";
import axios from "../../../axios/index";

import { UserContext } from "../../Context/UserContextProvider";

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

import { useLocation } from "react-router-dom";

// components
import HomeNavbar from "../HomeNavbar/HomeNavbar";
import Footer from "../Footer/Footer";
import UserFilesToShowHeader from "./Header/UserFilesToShowHeader";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import SearchBox from "./SearchBox/SearchBox";
import Estates from "./Card/Estates";
import FilterModal from "../../Dashboard/DashboardFileManagement/FilterModal/FilterModal";

// styles
// import styles from "./UserFilesToShow.module.css"
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import HeaderCategorySelector from "./HeaderCategorySelector/HeaderCategorySelector";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import CustomPagination from "../../CustomPagination/CustomPagination";

const UserFilesToShow = () => {
  const { state } = useLocation();
  const { deal, use, property, region } = useParams(); //only the deal is used since others are only for SEO and we get those data from states after changing a page
  const [query, setQuery] = useState("");
  const [estatesData, setEstatesData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 1,
  });
  const [filterParams, setFilterParams] = useState({
    place: "",
    room: "",
    floor: "",
    startPrice: "",
    fileCode: "",
    endPrice: "",
    metraj: [0, 100000],
    startMortaje: "",
    endMortaje: "",
    startRent: "",
    endRent: "",
    showList: false,
    showModal: false,
    dataChanged: false,
  });

  function generateCategoriesString() {
    let queryString = "";

    if (selectedDealType != -1) {
      queryString += "&DealType=" + selectedDealType;

      if (selectedUseType != 0) {
        queryString += "&MainCategory=" + selectedUseType;

        if (selectedPropertyType != 0) {
          queryString += "&SubCategory=" + selectedPropertyType;

          selectedRegions.forEach(region => {
            queryString += "&RegionCategories=" + selectedRegions;
          });
        }
      }
    }
    return queryString;
  }

  let [selectedDealType, setSelectedDealType] = useState(-1);
  let [selectedUseType, setSelectedUseType] = useState(0);
  let [selectedPropertyType, setSelectedPropertyType] = useState(0);
  let [selectedRegions, setSelectedRegions] = useState([]);

  function getDealType(deal) {
    switch (deal) {
      case "خرید":
      default:
        return 0;
      case "رهن-و-اجاره":
        return 1;
      case "پیش-فروش":
        return 2;
      case "مشارکت":
        return 3;
    }
  }

  useEffect(() => {
    if ("dealType" in (state || {})) {
      setSelectedDealType(state?.dealType == -1 ? getDealType(deal) : state?.dealType || getDealType(deal));
    } else {
      setSelectedDealType(getDealType(deal));
    }
    if ("useType" in (state || {})) {
      setSelectedUseType(state?.useType);
    }
    if ("propertyType" in (state || {})) {
      setSelectedPropertyType(state?.propertyType);
    }
    if ("region" in (state || {})) {
      setSelectedRegions(state?.region);
    }
  }, []);

  let lastTaskIdRef = useRef(null);

  function reloadData(ev, value) {
    setPage(prev => {
      return { ...prev, pageNumber: value };
    });

    let randomTaskId = Math.random();

    lastTaskIdRef.current = randomTaskId;

    axios
      .get(
        `Home/GetProducts?PageId=${value}${generateCategoriesString()}&EstateType=2&EstateRegion=1&Take=9&Zone=${filterParams.place}${
          filterParams.startPrice && `&StartTotalPrice=${filterParams.startPrice}`
        }${filterParams.endPrice && `&EndTotalPrice=${filterParams.endPrice}`}&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${
          filterParams.metraj[1]
        }&BedRoomCount=${filterParams.room !== undefined ? filterParams.room : ""}&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
          filterParams.floor !== undefined ? filterParams.floor : ""
        }`
      )
      .then(res => {
        // console.log(res.data.data);

        if (lastTaskIdRef.current != randomTaskId) {
          return;
        }

        // console.log(res.data.data);

        setPage(prev => {
          return { ...prev, pageCount: res.data.data.pageCount };
        });
        setEstatesData(res.data.data.data);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    let randomTaskId = Math.random();

    lastTaskIdRef.current = randomTaskId;

    console.log(randomTaskId);

    axios
      .get(`Home/GetProducts?PageId=${state?.pageNumber ? state?.pageNumber : "1"}${generateCategoriesString()}&EstateType=2&EstateRegion=1&Take=9`)
      .then(res => {
        // console.log(lastTaskIdRef.current);
        // console.log(randomTaskId);
        // console.log(res.data.data);

        if (lastTaskIdRef.current != randomTaskId) {
          return;
        }
        // console.log(res.data.data);

        setPage(prev => {
          return { ...prev, pageCount: res.data.data.pageCount };
        });
        setEstatesData(res.data.data.data);
        setIsLoading(false);
      });

    return () => {};
  }, [selectedDealType, selectedPropertyType, selectedRegions, selectedUseType]);

  console.log(page);

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar navSale={selectedDealType != 1} navRent={selectedDealType == 1} />
            <HeaderCategorySelector
              dataHandler={reloadData}
              filterParams={filterParams}
              setFilterParams={setFilterParams}
              dealType={selectedDealType}
              useType={selectedUseType}
              propertyType={selectedPropertyType}
              regions={selectedRegions}></HeaderCategorySelector>
            {/*<UserFilesToShowHeader sale setFilterParams={setFilterParams} />
                            <SearchBox query={query} setQuery={setQuery} sell setPage={setPage} setEstatesData={setEstatesData} setIsLoading={setIsLoading} resetState={resetState} />*/}
            <section className="container py-3 px-0">
              <div className="w-100 d-flex justify-content-center flex-wrap align-items-center mt-3" dir="rtl">
                <Estates
                  cardData={estatesData}
                  usePriceSeprator={usePriceSeprator}
                  saleCards={selectedDealType != 1}
                  callConsultant
                  pageNum={page.pageNumber}
                  query={query}
                />
              </div>
            </section>
            <Stack
              className={Dstyles.pagination}
              spacing={1}
              sx={{
                direction: "ltr",
                bottom: "0",
                height: "85px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center !important",
              }}>
              {/* <Typography>Page: {page}</Typography> */}
              <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={reloadData} />
              <div dir="rtl">
                انتخاب صفحه:{" "}
                <input
                  style={{
                    width: "50px",
                    border: "1px solid #aaa",
                    borderRadius: "10px",
                    height: "35px",
                    textAlign: "center",
                  }}
                  type="number"
                  max={page.pageCount}
                  min={1}
                  defaultValue={page.pageNumber}
                  id="paginationInput"
                  onKeyDown={paginationInputEnterHandler}
                  // onChange={paginationInputHandler}
                />
              </div>
            </Stack>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    axios.get(`Home/GetProducts?PageId=${value}${generateCategoriesString()}&EstateType=2&EstateRegion=1&Take=9`).then(res => {
      setPage({ pageNumber: value, pageCount: res.data.data.pageCount });

      setEstatesData(res.data.data.data);
      setIsLoading(false);
    });
  }

  function paginationInputEnterHandler(e) {
    console.log(e);
    if (e.key === "Enter") {
      console.log("target", e.target.value);

      paginationHandler(undefined, e.target.value);
      const url = new URL(window.location);
      url.searchParams.set("page", e.target.value);
      window.history.pushState({}, "", url);
    }
  }
  function paginationInputHandler(e) {
    console.log(e);
    setPage({
      ...page,
      pageNumber: e.target.value,
    });
  }
};

export default React.memo(UserFilesToShow);
